module.exports = __webpack_public_path__ + "e9fcbdae761bf1044a3a671e45ea18b8.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/paypal-solo.svg
// module id = 1457
// module chunks = 1 5 7 8 15 80